import React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { createLocalStorageStateHook } from 'use-local-storage-state'
import './App.scss'
import './i18n'

export const useXPageState = createLocalStorageStateHook('xPageId')

const loading = () => (
  <div className='animated fadeIn pt-3 text-center'>Loading...</div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./containers/DefaultLayout'))

const App = () => (
  <BrowserRouter>
    <React.Suspense fallback={loading()}>
      <Switch>
        <Route
          path='/'
          name='Home'
          render={props => <DefaultLayout {...props} />}
        />
      </Switch>
    </React.Suspense>
  </BrowserRouter>
)

export default App
